import { type ComponentProps } from 'react';
import { Modal as HeroModal } from '@heroui/react';
import { cn } from '../utils';

const Root = (props: ComponentProps<typeof HeroModal.Root>) => <HeroModal.Root {...props} />;

const Backdrop = ({
  className,
  variant = 'blur',
  ...props
}: ComponentProps<typeof HeroModal.Backdrop>) => (
  <HeroModal.Backdrop className={cn('bg-background/65', className)} variant={variant} {...props} />
);

const Container = ({
  className,
  size = 'md',
  scroll = 'outside',
  ...props
}: ComponentProps<typeof HeroModal.Container>) => (
  <HeroModal.Container className={cn('px-4', className)} size={size} scroll={scroll} {...props} />
);

const Dialog = ({ className, ...props }: ComponentProps<typeof HeroModal.Dialog>) => (
  <HeroModal.Dialog
    className={cn(
      'border border-default-200/80 shadow-[0_24px_60px_-30px_rgb(15_23_42_/_0.55)]',
      className
    )}
    {...props}
  />
);

const Header = ({ className, ...props }: ComponentProps<typeof HeroModal.Header>) => (
  <HeroModal.Header className={cn('gap-2', className)} {...props} />
);

const Body = ({ className, ...props }: ComponentProps<typeof HeroModal.Body>) => (
  <HeroModal.Body className={cn('text-sm leading-6 text-default-600', className)} {...props} />
);

const Footer = ({ className, ...props }: ComponentProps<typeof HeroModal.Footer>) => (
  <HeroModal.Footer className={cn('gap-2', className)} {...props} />
);

export const Modal = Object.assign(Root, {
  Backdrop,
  Container,
  Dialog,
  Header,
  Icon: HeroModal.Icon,
  Heading: HeroModal.Heading,
  Body,
  Footer,
  CloseTrigger: HeroModal.CloseTrigger,
  Trigger: HeroModal.Trigger,
  Root
});
